import {CURRENCY_CURRENT, CURRENCY_USD, CURRENCY_ZWG} from "../core/data/global";

const routes = [
    // {
    //     // show service providers
    //     path: '/new/service/:service/:provider?',
    //     component: require('../components/bills/new/shells/service-shell.vue').default,
    // },
    // {
    //     // show provider services
    //     path: '/new/provider/:provider/:service?',
    //     component: require('../components/bills/new/shells/provider-shell.vue').default,
    // },
    // {
    //     // straight to service
    //     path: '/new/:service?/:provider?',
    //     component: require('../components/bills/new/shells/shell.vue').default,
    // },


    {
        path: '/',
        component: require('../components/webiste/home').default,
    },
    {
        path: '/nijo',
        component: require('../components/webiste/home').default,
    },
    {
        path: '/transaction/check',
        component: require('../components/bills/check').default,
        children: [
            {
                path: '/transaction/check',
                component: require('../components/bills/check/init').default,
            },
        ]
    },
    {
        path: '/service',
        component: require('../components/bills/home').default,
        children: [
            {
                path: '/zesa',
                component: require('../components/bills/zesa').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },

                ]
            },
            {
                path: '/zesa/view-token',
                component: require('../components/bills/calculators/view-token/view-token-layout.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/calculators/view-token/view-token.vue').default,
                    },
                ]
            },
            {
                path: '/zesa/buy-zesa',
                component: require('../components/bills/seo-content/buy-zesa.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },

                ]
            },
            {
                path: '/zesa-token',
                component: require('../components/bills/seo-content/zesa-tokens.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },

                ]
            },
            {
                path: '/zesa-apr-25-1',
                component: require('../components/bills/seo-content/zesa-tokens.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },

                ]

            },
            {
                path: '/zesa-apr-25-2',
                component: require('../components/bills/seo-content/zesa-tokens.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },

                ]

            },
            {
                path: '/airtime-feb-march-diaspora',
                component: require('../components/bills/seo-content/sending-airtime-to-zimbabwe.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/seo-content/sending-airtime-to-zimbabwe.vue').default,
                    },

                ]

            },


            {
                path: '/zesa-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/zesa/ecocash',
                        component: require('../components/bills/core/ecocash').default,
                    },
                    {
                        path: '/zesa/stripe',
                        component: require('../components/bills/core/stripe').default,
                    },
                    {
                        path: '/zesa/complete',
                        component: require('../components/bills/zesa/token').default,
                    }
                ]
            },

            {
                path: '/airtime',
                component: require('../components/bills/airtime').default,
                children: [
                    {
                        path: '/airtime',
                        component: require('../components/bills/airtime/init').default,
                        beforeEnter: (to, from, next) => {
                            // Check the currency and redirect if necessary
                            if (CURRENCY_CURRENT === CURRENCY_ZWG) {
                                next('/airtime/zwg'); // Redirect to '/airtime/zwg' if currency is ZWG
                            } else {
                                next(); // Continue to the route
                            }
                        }
                    },
                    {
                        path: '/airtime/zwg',
                        component: require('../components/bills/airtime/init').default,
                        beforeEnter: (to, from, next) => {
                            // Check the currency and redirect if necessary
                            if (CURRENCY_CURRENT === CURRENCY_USD) {
                                next('/airtime'); // Redirect to '/airtime/usd' if currency is ZWG
                            } else {
                                next(); // Continue to the route
                            }
                        }
                    },
                    {
                        path: '/airtime/netone',
                        component: CURRENCY_CURRENT === CURRENCY_ZWG
                            ? require('../components/bills/airtime/init').default
                            : require('../components/bills/bundles/netone').default,
                    }
                ]
            },

            {
                path: '/airtime-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/airtime/ecocash',
                        component: require('../components/bills/core/ecocash').default,
                    },
                    {
                        path: '/airtime/stripe',
                        component: require('../components/bills/core/stripe').default,
                    },
                    {
                        path: '/airtime/complete',
                        component: require('../components/bills/airtime/token').default,
                    }
                ]
            },

            {
                path: '/gift-vouchers',
                component: require('../components/bills/giftcards/_layout').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/giftcards/init').default,
                    },
                    {
                        path: 'purchase/:id',
                        component: require('../components/bills/giftcards/purchase').default,
                    },
                    {
                        path: 'terms/:id',
                        component: require('../app/consumer/views/gift-cards.terms.vue').default,
                    },
                ]
            },
            {
                path: '/gift-cards-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/gift-cards/ecocash',
                        component: require('../components/bills/core/ecocash').default,
                    },
                    {
                        path: '/gift-cards/stripe',
                        component: require('../components/bills/core/stripe').default,
                    },
                    {
                        path: '/gift-cards/complete',
                        component: require('../components/bills/giftcards/token').default,
                    }
                ]
            },

            {
                path: '/tickets',
                component: require('../app/consumer/views/tickets/layout.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../app/consumer/views/tickets/index.vue').default,
                    },
                    {
                        path: 'buy/:id/:name',
                        component: require('../app/consumer/views/tickets/purchase.vue').default,
                    },

                    {
                        path: '/tickets/landing',
                        component: require('../app/consumer/views/tickets/tickets-landing.vue').default,
                    }


                ]
            },
            {
                path: '/tickets-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/tickets/ecocash',
                        component: require('../components/bills/core/ecocash.vue').default,
                    },
                    {
                        path: '/tickets/stripe',
                        component: require('../components/bills/core/stripe.vue').default,
                    },
                    {
                        path: '/tickets/complete',
                        component: require('../app/consumer/views/tickets/token.vue').default,
                    }
                ]
            },
            //Billers
            {
                path: '/billers',
                component: require('../app/consumer/billers/layout.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../app/consumer/billers/index.vue').default,
                    },
                    {
                        path: 'pay/:id/:name',
                        component: require('../app/consumer/billers/purchase.vue').default,
                    },
                    {
                        path: '/billers/landing',
                        component: require('../app/consumer/billers/billers-landing.vue').default,
                    }

                ]
            },
            {
                path: '/billers-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/billers/ecocash',
                        component: require('../components/bills/core/ecocash.vue').default,
                    },
                    {
                        path: '/billers/stripe',
                        component: require('../components/bills/core/stripe.vue').default,
                    },
                    {
                        path: '/billers/complete',
                        component: require('../app/consumer/billers/token.vue').default,
                    }
                ]
            },
            //Biller End

            {
                path: '/zinara',
                component: require('../components/bills/zinara').default,
                children: [
                    {
                        path: '/zinara',
                        component: require('../components/bills/zinara/register').default,
                    },
                    {
                        path: '/zinara/vehicles/create',
                        component: require('../components/bills/zinara/create').default,
                    },
                    {
                        path: '/zinara/vehicles',
                        component: require('../components/bills/zinara/vehicles').default,
                    },
                ]
            },
            {
                path: '/zinara-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/zinara/ecocash',
                        component: require('../components/bills/core/ecocash').default,
                    },
                    {
                        path: '/zinara/stripe',
                        component: require('../components/bills/core/stripe').default,
                    },
                    {
                        path: '/zinara/complete',
                        component: require('../components/bills/zinara/token').default,
                    }
                ]
            },

            {
                path: '/bundles',
                component: require('../components/bills/bundles').default,
                children: [
                    {
                        path: '/bundles/zwg',
                        component:  require('../components/bills/bundles/econet.vue').default,
                        beforeEnter: (to, from, next) => {
                            if (CURRENCY_CURRENT === CURRENCY_USD) {
                                next('/bundles');
                            } else {
                                next();
                            }
                        }
                    },
                    {
                        path: '/bundles',
                        component: require('../components/bills/bundles/smart').default,
                        beforeEnter: (to, from, next) => {
                            if (CURRENCY_CURRENT === CURRENCY_ZWG) {
                                next('/bundles/zwg');
                            } else {
                                next();
                            }
                        }
                    },
                    {
                        path: '/bundles/smartsuite',
                        component: require('../components/bills/bundles/smartbiz.vue').default,
                    },
                    {
                        path: '/bundles/netone',
                        component: require('../components/bills/bundles/netone').default,
                    },
                    /*{
                        path: '/bundles/telone',
                        component: require('../components/bills/telone/bundle').default,
                    },*/

                    {
                        path: '/bundles/telone/zwg',
                        component:  require('../components/bills/telone/bundle').default,
                        beforeEnter: (to, from, next) => {
                            // Check the currency and redirect if necessary
                            if (CURRENCY_CURRENT === CURRENCY_USD) {
                                next('/bundles/telone'); // Redirect  if currency is USD
                            } else {
                                next(); // Continue to the route
                            }
                        }
                    },
                    {
                        path: '/bundles/telone',
                        component: require('../components/bills/telone/bundle').default,
                        beforeEnter: (to, from, next) => {
                            // Check the currency and redirect if necessary
                            if (CURRENCY_CURRENT === CURRENCY_ZWG) {
                                next('/bundles/telone/zwg'); // Redirect if currency is ZWG
                            } else {
                                next(); // Continue to the route
                            }
                        }
                    },
                ]
            },
            {
                path: '/bundles-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/bundles/ecocash',
                        component: require('../components/bills/core/ecocash').default,
                    },
                    {
                        path: '/bundles/stripe',
                        component: require('../components/bills/core/stripe').default,
                    },
                    {
                        path: '/bundles/complete',
                        component: require('../components/bills/bundles/token').default,
                    }
                ]
            },

            {
                path: '/telone',
                component: require('../components/bills/telone').default,
                children: [
                    {
                        path: '/telone',
                        component: require('../components/bills/telone/recharge').default,
                        beforeEnter: (to, from, next) => {
                            if (CURRENCY_CURRENT === CURRENCY_USD) {
                                next('/telone/usd');
                            } else {
                                next();
                            }
                        }
                    },
                    {
                        path: '/telone/usd',
                        component: require('../components/bills/telone/recharge').default,
                        beforeEnter: (to, from, next) => {
                            if (CURRENCY_CURRENT === CURRENCY_ZWG) {
                                next('/telone');
                            } else {
                                next();
                            }
                        }
                    },
                    {
                        path: '/telone/bundle',
                        component: require('../components/bills/telone/bundle').default,
                    },
                    {
                        path: '/telone/bill',
                        component: require('../components/bills/telone/bill').default,
                    },
                ]
            },
            {
                path: '/telone-payment',
                component: require('../components/bills/bill-confirm.vue').default,
                children: [
                    {
                        path: '/telone/ecocash',
                        component: require('../components/bills/core/ecocash').default,
                    },
                    {
                        path: '/telone/stripe',
                        component: require('../components/bills/core/stripe').default,
                    },
                    {
                        path: '/telone/complete',
                        component: require('../components/bills/telone/token').default,
                    }
                ]
            },
            //UTM-URLS
            {
                path: '/zesa-jun-26',
                component: require('../components/bills/zesa').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },
                ]
            },
            {
                path: '/ca',
                beforeEnter: () => {
                    window.location.href = 'https://beta.magetsi.co.zw/register/individual';
                },
            },
            {
                path: '/card-ca',
                beforeEnter: () => {
                    window.location.href = 'https://beta.magetsi.co.zw/register/individual';
                },
            },
            {
                path: '/banner-ca',
                beforeEnter: () => {
                    window.location.href = 'https://beta.magetsi.co.zw/register/individual';
                },
            },
            {
                path: '/zesa-new-apr-26',
                component: require('../components/bills/zesa').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/zesa/init').default,
                    },
                ]
            },
            {
                path: '/zesa-tariffs-ad',
                component: require('../components/bills/seo-content/tariffs.vue').default,
            },
            {
                path: '/WhatsAppSEP',
                component: require('../components/bills/utm/whatsapp-utm.vue').default,
            },
            //SEO-URLS
            {
                path: '/zesa-tariffs',
                component: require('../components/bills/seo-content/tariffs.vue').default,
            },
            {
                path: "/giveaway-landing",
                component: require('../components/bills/seo-content/giveaway-landing.vue').default,
            },
            {
                path: '/zesa-portal',
                component: require('../components/bills/seo-content/zesa-portal.vue').default,
            },
            {
                path: '/diaspora',
                component: require('../components/bills/seo-content/diaspora.vue').default,
            },
            {
                path: '/maximise-your-zesa-savings',
                component: require('../components/bills/seo-content/maximise-your-zesa-savings.vue').default,
            },
            {
                path: '/maximise-your-zesa-savings-A',
                component: require('../components/bills/seo-content/maximise-your-zesa-savings.vue').default,
            },
            {
                path: '/maximise-your-zesa-savings-B',
                component: require('../components/bills/seo-content/maximise-your-zesa-savings.vue').default,
            },
            {
                path: '/maximise-your-zesa-savings-C',
                component: require('../components/bills/seo-content/maximise-your-zesa-savings.vue').default,
            },
            {
                path: '/zesa-calculator',
                redirect: '/calculators/zesa-calculator',
            },

            {
                path: '/how-to-buy-netone-airtime-using-ecocash',
                component: require('../components/bills/seo-content/how-to-buy-netone-airtime-using-ecocash.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/bundles/netone.vue').default,
                    },
                ]
            },

            {
                path: '/bundles/smartsuite',
                component: require('../components/bills/seo-content/smart-suite.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/bundles/smartbiz.vue').default,
                    },
                ]
            },

            // Additional Calculators
            {
                path: '/calculators',
                redirect: '/calculators/zesa-calculator',
                component: require('../components/bills/calculators/calculators-layout.vue').default,

                children: [
                    {
                        path: 'zesa-calculator',
                        component: require('../components/bills/calculators/zesa/zesa-calculator.vue').default,
                    },
                    {
                        path: 'currency-calculator',
                        component: require('../components/bills/calculators/currency-exchange-rate/currency-calculator.vue').default,
                    },

                    {
                        path: 'loan-calculator',
                        component: require('../components/bills/calculators/loan/loan-calculator.vue').default,
                    },
                    {
                        path: 'savings-calculator',
                        component: require('../components/bills/calculators/savings-growth/savings-calculator.vue').default,
                    },
                    {
                        path: 'mortgage-calculator',
                        component: require('../components/bills/calculators/mortgage/mortgage-calculator.vue').default,
                    },
                    {
                        path: 'solar-savings-calculator',
                        component: require('../components/bills/calculators/solar-savings/solar-savings-calculator.vue').default,
                    },
                ],
            },
            {
                path: '/zesa-view-token',
                redirect: '/zesa/view-token',
            },
            {
                path: '/calculators/view-token',
                redirect: '/zesa/view-token',
            },
            /*{
                path: '/zrp-traffic',
                component: require('../components/bills/seo-content/tools-layout.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/seo-content/zrp-traffic.vue').default,
                    },

                ]
            },*/

            {
                path: '/sending-airtime-to-zimbabwe',
                component: require('../components/bills/seo-content/sending-airtime-to-zimbabwe.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/airtime/init').default,
                        beforeEnter: (to, from, next) => {
                            // Check the currency and redirect if necessary
                            if (CURRENCY_CURRENT === CURRENCY_ZWG) {
                                next('/airtime/zwg'); // Redirect to '/airtime/zwg' if currency is ZWG
                            } else {
                                next(); // Continue to the route
                            }
                        }
                    },
                ]
            },
            {
                path: '/telone-wifi-packages',
                component: require('../components/bills/seo-content/telone-wifi.vue').default,
                children: [
                    {
                        path: '/',
                        component: require('../components/bills/telone/recharge').default,
                    },
                ]
            },
            //SEO-URLS
            {
                path: '/auth/login',
                component: require('../components/webiste/auth/Login').default,
            }
        ]
    },

    {
        path: '/auth/register',
        component: require('../components/webiste/auth/Register.vue').default,
    },
    {
        path: '/profile',
        component: require('../components/profile/open').default,
        children: [

            {
                path: '/profile',
                component: require('../components/profile/edit').default,
            },

            {
                path: '/profile/password',
                component: require('../components/profile/password').default,
            },

            {
                path: '/transactions',
                component: require('../components/profile/transactions').default,
            },

            {
                path: '/transactions/batch',
                component: require('../components/profile/batch').default,
            },

            {
                path: '/notifications',
                component: require('../components/profile/notifications').default,
            },

        ]
    },
];

export default routes;
